module.exports = __webpack_public_path__ + "img/電気回路_3_4_2.dbee100c.png";